import React, { useRef } from 'react';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ActionButton from '../buttons/ActionButton';

const SearchBar = ({
    children,
    filter,
    submitFilter,
    setFilter
}) => {
    const inputRef = useRef(null);

    const keyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            submitFilter();
        }
    }

    return(
        <div className="search-bar">
            <div className="form-row justify-content-center">
                <Col xs="auto">
                    <Form.Control
                        ref={inputRef}
                        autoComplete="off"
                        defaultValue={filter.searchString}
                        name="searchString"
                        onChange={setFilter}
                        placeholder="Search"
                        onKeyDown={keyDown}
                    />
                </Col>
                <div style={{ position: 'relative', maxWidth: '0' }}>
                    <div 
                        className='action-button'
                        style={{ position: 'absolute', right: '10px', top: '5px', color:'#aaaaaa', fontSize:'.75rem', padding: '3px' }}
                        onClick={() => {
                            inputRef.current.value = '';
                            setFilter({ target: { name: 'searchString', value: '' } });
                            inputRef.current.focus();
                            submitFilter();
                        }}>X
                    </div>
                </div>
                <Col xs="auto">
                    <ActionButton
                        buttonText="Search"
                        imgSource="/images/search.svg"
                        onClick={submitFilter}/>
                </Col>
                {children}
            </div>
        </div>
    );
}


export default SearchBar;